import { MY_WORK_REFRESH_MS } from './constants';
import type { MyWorkSourceId } from '../types/myWork';

const KIND_LABELS: Record<string, string> = {
  'ops_action.overdue': 'Action overdue',
  'ops_action.due': 'Action due',
  'trip_review.evc_review': 'Approve trip',
  'trip_review.principal_review': 'Approve trip',
  'trip_review.od_review': 'Approve trip',
  'atr_gate.first_gate': 'First-gate decision',
  'atr_gate.function_head': 'Function Head decision',
  'atr_gate.finance': 'Finance decision',
};

const DATE_LABELS = { starts: 'Starts', due: 'Due', since: 'Since' } as const;

export function myWorkKindLabel(kind: string): string {
  return KIND_LABELS[kind] ?? 'Open work';
}

export function myWorkDateLabel(dateKind: keyof typeof DATE_LABELS): string {
  return DATE_LABELS[dateKind];
}

/** Visible and accessible count. Zero has no number. Above 99 renders 99+. */
export function myWorkCountLabel(total: number | null): { text: string; accessibleName: string } {
  if (total === null || total <= 0) {
    return { text: 'My work', accessibleName: 'My work' };
  }
  const shown = total > 99 ? '99+' : String(total);
  return { text: 'My work', accessibleName: `My work, ${shown}` };
}

export function myWorkShownCount(total: number | null): string | null {
  if (total === null || total <= 0) return null;
  return total > 99 ? '99+' : String(total);
}

export function myWorkUnavailableCopy(source: MyWorkSourceId): string {
  if (source === 'ops_action') return 'Actions could not be loaded.';
  if (source === 'trip_review') return 'Trips could not be loaded.';
  return 'Recruitment decisions could not be loaded.';
}

export function myWorkTruncatedCopy(source: MyWorkSourceId): string {
  if (source === 'ops_action') return 'Some actions are not listed.';
  if (source === 'trip_review') return 'Some trips are not listed.';
  return 'Some recruitment decisions are not listed.';
}

export function myWorkTruncatedHref(source: MyWorkSourceId): string {
  if (source === 'ops_action') return '/weekly-report/my-actions';
  if (source === 'trip_review') return '/trips/review';
  return '/hr/request-new-hire-atr/pending-approval';
}

export function shouldRefreshMyWork(
  lastFetchedAt: number,
  now: number,
  minMs: number = MY_WORK_REFRESH_MS,
): boolean {
  return now - lastFetchedAt >= minMs;
}
